import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

const NAV = [
  { to: '/admin/novels', label: 'Novels' },
  { to: '/admin/utm', label: 'UTM Mappings' },
  { to: '/admin/accounts', label: 'Accounts' },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  // Verify admin session once when the layout mounts — this stays mounted
  // across all nested /admin/* routes via <Outlet/>, so this doesn't re-run
  // on every admin page navigation.
  useEffect(() => {
    fetch('/api/admin/me', { credentials: 'include' })
      .then(r => { if (!r.ok) navigate('/admin/login', { replace: true }); else setChecked(true); })
      .catch(() => navigate('/admin/login', { replace: true }));
  }, [navigate]);

  async function handleLogout() {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
    navigate('/admin/login');
  }

  if (!checked) return null;

  return (
    <div style={s.page}>
      <aside style={s.sidebar}>
        <div style={s.brand}>Classroom.Bingo<br /><span style={s.brandSub}>Admin</span></div>
        <nav>
          {NAV.map(n => (
            <NavLink key={n.to} to={n.to} style={({ isActive }) => ({
              ...s.navLink, ...(isActive ? s.navActive : {}),
            })}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={handleLogout} style={s.logoutBtn}>Log out</button>
      </aside>
      <main style={s.main}><Outlet /></main>
    </div>
  );
}

const s = {
  page: { display: 'flex', minHeight: '100vh', fontFamily: 'system-ui, sans-serif' },
  sidebar: { width: '200px', minWidth: '200px', backgroundColor: '#1a1a2e', display: 'flex',
    flexDirection: 'column', padding: '0' },
  brand: { padding: '20px 16px', fontSize: '15px', fontWeight: '700', color: '#d4a017',
    borderBottom: '1px solid rgba(255,255,255,0.1)' },
  brandSub: { fontSize: '11px', color: 'rgba(255,255,255,0.45)', fontWeight: '400' },
  navLink: { display: 'block', padding: '10px 16px', color: 'rgba(255,255,255,0.6)',
    textDecoration: 'none', fontSize: '14px', borderLeft: '3px solid transparent' },
  navActive: { color: '#fff', fontWeight: '600', borderLeftColor: '#d4a017',
    backgroundColor: 'rgba(255,255,255,0.07)' },
  logoutBtn: { marginTop: 'auto', margin: '16px', padding: '8px', backgroundColor: 'transparent',
    border: '1px solid rgba(255,255,255,0.2)', borderRadius: '6px', color: 'rgba(255,255,255,0.5)',
    fontSize: '13px', cursor: 'pointer' },
  main: { flex: 1, backgroundColor: '#f9fafb', padding: '32px', overflowY: 'auto' },
};
